@if (router.url === '/health') {
  <router-outlet></router-outlet>
} @else {
  <app-header class="aker-dark-theme" [akerTitle]="title" [titleClickUrl]="titleClickUrl"></app-header>
  @if (isAdminRoute) {
    <div class="page-container admin-page">
      <router-outlet></router-outlet>
    </div>
  } @else {
    <div class="page-container">
      <app-side-navigation class="aker-dark-theme" [isOnline]="!offlineMode"></app-side-navigation>
      <div class="main-container">
        <app-context-toolbar [isOnline]="!offlineMode" [isAdmin]="isAdmin"></app-context-toolbar>
        <main class="page-content">
          <router-outlet></router-outlet>
        </main>
        @if (offlineMode) {
          <footer>
            <app-offline-toolbar></app-offline-toolbar>
          </footer>
        }
      </div>
    </div>
  }
}

<app-notification-container></app-notification-container>
